exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#admin-container {\n  margin-top: -25px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column; }\n  #admin-container #admin-body-container {\n    display: -ms-flexbox;\n    display: flex;\n    width: 100%; }\n    #admin-container #admin-body-container .routing-pannel {\n      min-height: calc(100vh - 125px);\n      background-color: white; }\n    #admin-container #admin-body-container .router-outlet {\n      margin: 0 auto;\n      min-width: 75%; }\n  @media screen and (max-width: 768px) {\n    #admin-container #admin-body-container {\n      -ms-flex-direction: column;\n          flex-direction: column; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/app-root/src/src/app/components/admin/admin.component.scss
// module id = ../../../../../src/app/components/admin/admin.component.scss
// module chunks = main